<p-dialog
  #eventWizardModal
  modal="true"
  [(visible)]="showModal"
  [closable]="false"
  styleClass="atlas-dialog-xl"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '65vh' }"
>
  <ng-template pTemplate="header">
    <h3>{{ event.EventName }}</h3>
    <div [hidden]="_loadingEventForRegistration">
      {{ event?.StartDate | date: 'fullDate' }}<span *ngIf="event?.StartTime">, {{ event?.StartTime }}</span>
      <span *ngIf="(event?.StartDate | date: 'yMd') != (event?.EndDate | date: 'yMd')"
        >- {{ event?.EndDate | date: 'fullDate' }}<span *ngIf="event?.EndTime">, {{ event?.EndTime }}</span></span
      >
      <span
        *ngIf="(event?.StartDate | date: 'yMd') == (event?.EndDate | date: 'yMd') && event?.EndTime && event?.StartTime != event?.EndTime"
        >- {{ event?.EndTime }}</span
      >
      <div>{{ 'events.registration.wizard.title' | translate | titlecase }}</div>
    </div>
  </ng-template>
  <div *ngIf="_loadingEventForRegistration || _loadingRegistration">
    <wl-busy [show]="_loadingEventForRegistration || _loadingRegistration"></wl-busy> {{ 'common.loading' | translate | ucfirst }}
  </div>
  <form #registrationForm [hidden]="_loadingEventForRegistration || _loadingRegistration">
    <wlx-tabs #registrationWizardTabsComponent>
      <wlx-tab title="{{ 'events.registration.wizard.contact.title' | translate | titlecase }}" #registrationWizardContactTab>
        <wl-registration-wizard-contact
          #registrationWizardContactComponent
          (onRegistrationProfileChanged)="registrationProfileChanged($event)"
        ></wl-registration-wizard-contact>
      </wlx-tab>
      <wlx-tab title="{{ 'events.registration.wizard.items.title' | translate | titlecase }}" #registrationWizardItemsTab>
        <wl-registration-wizard-items
          #registrationWizardItemsComponent
          (onRegistrationItemsChanged)="registrationItemsChanged()"
        ></wl-registration-wizard-items>
      </wlx-tab>
      <wlx-tab title="{{ 'events.registration.wizard.attendees.title' | translate | titlecase }}" #registrationWizardAttendeesTab>
        <wl-registration-wizard-attendees
          #registrationWizardAttendeesComponent
          [registrationProfile]="_registrationProfile"
        ></wl-registration-wizard-attendees>
      </wlx-tab>
      <wlx-tab [isTabWellContent]="true">
        <ng-template>
          <wl-registration-wizard-attendee-tab-nav
            [attendees]="registration?.Attendees"
            [enableNewButton]="_attendeesLoaded && registrationWizardAttendeesComponent.canAddNewAttendee"
            (onAddAttendee)="handleAttendeeNavAddNewAttendeeClick()"
            (onAttendeeClick)="handleAttendeeNavAttendeeClick($event)"
          ></wl-registration-wizard-attendee-tab-nav>
        </ng-template>
      </wlx-tab>
      <wlx-tab title="{{ 'events.registration.wizard.payment-info.title' | translate | titlecase }}" #registrationWizardPaymentTab>
        <wl-registration-wizard-payment-info #registrationWizardPaymentInfoComponent></wl-registration-wizard-payment-info>
      </wlx-tab>
      <wlx-tab
        title="{{ 'events.registration.wizard.sponsor.title' | translate | titlecase }}"
        [enabled]="!registration.IsEdit && _sponsorTabEnabled"
        #registrationWizardSponsorTab
      >
        <wl-registration-wizard-sponsor #registrationWizardSponsorComponent></wl-registration-wizard-sponsor>
      </wlx-tab>
    </wlx-tabs>
  </form>

  <ng-template class="mct-flex mct-row mct-justify-between mct-items-center" pTemplate="footer">
    <div class="mct-flex mct-row mct-justify-center mct-items-center">
      <p-select
        class="mr-10"
        placeholder="{{ 'events.registration.wizard.select-profile-to-jump-to' | translate }}"
        [(ngModel)]="selectedJumpToProfileId"
        [options]="jumpToProfilesItems"
      ></p-select>
      <a target="_blank" [routerLink]="['profile', selectedJumpToProfileId]">
        <button pButton type="button" class="atlas-btn atlas-btn-default" [disabled]="!selectedJumpToProfileId">
          {{ 'events.registration.wizard.open-profile' | translate | uppercase }}
        </button>
      </a>
    </div>
    <div>
      <div *ngIf="!validationResult.isValid && validationResult.errors.length > 0" class="alert alert-danger">
        {{ validationResult.error }}
        <ul [hidden]="!validationResult.errors">
          <li *ngFor="let error of validationResult.errors">
            {{ error }}
          </li>
        </ul>
      </div>
      <div [hidden]="_loadingEventForRegistration">
        <wl-busy [show]="isSaving"></wl-busy>
        <button pButton type="button" class="btn btn-secondary" (click)="wizardCancel()" [disabled]="isSaving" icon="pi pi-ban">
          {{ 'common.cancel' | translate | titlecase }}
        </button>
        <button
          pButton
          type="button"
          [disabled]="registrationWizardTabsComponent.isOnFirstTab"
          class="btn btn-secondary"
          (click)="wizardBack()"
          icon="pi pi-chevron-left"
        >
          {{ 'common.back' | translate | titlecase }}
        </button>
        <button
          pButton
          [disabled]="registrationWizardTabsComponent.isOnLastTab || (registrationWizardItemsTab.selected && !hasSelectedEventItems)"
          type="button"
          class="btn btn-secondary"
          data-cy="btnRegistrationWizardNext"
          (click)="wizardNext()"
          icon="pi pi-chevron-right"
          iconPos="right"
        >
          {{ 'common.next' | translate | titlecase }}
        </button>
        <button
          pButton
          type="button"
          [disabled]="!hasSelectedEventItems || isSaving || _loadingEventForRegistration || !initialLoadComplete || !_attendeesLoaded"
          class="btn btn-primary"
          data-cy="btnRegistrationWizardSave"
          (click)="wizardSave()"
          icon="pi pi-save"
        >
          {{ 'common.save' | translate | titlecase }}
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>
